import { useState } from 'react';

export default function Hero() {
  const [subscribeEmail, setSubscribeEmail] = useState('');
  const [subscribeStatus, setSubscribeStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [subscribeError, setSubscribeError] = useState('');

  const handleSubscribe = (e: React.FormEvent) => {
    e.preventDefault();
    const honeypot = (e.currentTarget as HTMLFormElement).querySelector<HTMLInputElement>('input[name="phone_alt"]');
    if (honeypot?.value.trim()) {
      setSubscribeStatus('success');
      setSubscribeEmail('');
      setTimeout(() => setSubscribeStatus('idle'), 3000);
      return;
    }
    setSubscribeStatus('success');
    setSubscribeEmail('');
    setTimeout(() => setSubscribeStatus('idle'), 3000);
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 overflow-hidden opacity-[0.04] pointer-events-none">
        <div className="absolute top-10 left-10 text-9xl font-bold text-foreground-950 select-none">爆</div>
        <div className="absolute top-40 right-20 text-8xl font-bold text-foreground-950 select-none">料</div>
        <div className="absolute bottom-20 left-1/3 text-7xl font-bold text-foreground-950 select-none">瓜</div>
      </div>

      <div className="relative w-full px-4 md:px-6 lg:px-12 pt-[72px]">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center px-3 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold tracking-wide mb-5 whitespace-nowrap">
              <i className="ri-fire-line mr-1.5 text-sm"></i>
              今日爆料大赛火热进行中
            </div>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight tracking-tight mb-4">
              每日爆料
              <span className="block text-primary-500">你身边的吃瓜第一线</span>
            </h1>

            <p className="text-base md:text-lg text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-4">
              全网最热爆料，每天新鲜直达
            </p>

            <p className="text-sm md:text-base text-foreground-500 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6">
              每日爆料大赛是汇聚全网吃瓜群众的一站式爆料平台，覆盖娱乐圈、社会热点、行业黑幕等多元领域。
              每天更新最新爆料作品与赛况排名，提供便捷的爆料大赛活动入口，让你第一时间掌握最劲爆的内幕消息。
              当前赛季已有超过 2,800 条优质爆料作品参赛，话题覆盖影视综艺、科技数码、消费维权、职场内幕等热门方向。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 md:gap-8 mb-7">
              <div className="text-center">
                <div className="font-heading text-2xl md:text-3xl font-bold text-accent-500">2,800+</div>
                <div className="text-xs text-foreground-500 mt-1">参赛作品</div>
              </div>
              <div className="w-px h-10 bg-background-200 hidden sm:block"></div>
              <div className="text-center">
                <div className="font-heading text-2xl md:text-3xl font-bold text-accent-500">18.6万</div>
                <div className="text-xs text-foreground-500 mt-1">吃瓜群众</div>
              </div>
              <div className="w-px h-10 bg-background-200 hidden sm:block"></div>
              <div className="text-center">
                <div className="font-heading text-2xl md:text-3xl font-bold text-accent-500">实时更新</div>
                <div className="text-xs text-foreground-500 mt-1">赛况滚动播报</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mb-6">
              <a
                href="#ranking"
                className="inline-flex items-center px-6 py-3 bg-primary-500 text-background-50 font-semibold text-sm rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-trophy-line mr-2"></i>
                查看爆料热榜
              </a>
              <a
                href="#contact"
                className="inline-flex items-center px-6 py-3 bg-background-100 text-foreground-700 font-semibold text-sm rounded-lg border border-background-200 hover:border-primary-300 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-send-plane-line mr-2"></i>
                我要爆料
              </a>
            </div>

            <form onSubmit={handleSubscribe} className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-2 max-w-md mx-auto lg:mx-0">
              <div className="relative flex-1 w-full">
                <i className="ri-mail-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
                <input
                  type="email"
                  name="email"
                  value={subscribeEmail}
                  onChange={(e) => setSubscribeEmail(e.target.value)}
                  placeholder="输入邮箱，订阅每日爆料推送"
                  className="w-full pl-9 pr-4 py-2.5 text-sm bg-background-50 border border-background-200 rounded-lg focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-100 text-foreground-700 placeholder:text-foreground-400"
                />
              </div>
              <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly className="honeypot-field" />
              <button
                type="submit"
                className="px-5 py-2.5 bg-foreground-900 text-background-50 font-medium text-sm rounded-lg hover:bg-foreground-950 transition-colors whitespace-nowrap cursor-pointer"
              >
                订阅
              </button>
              {subscribeStatus === 'success' && (
                <span className="text-xs text-primary-500 whitespace-nowrap">订阅成功!</span>
              )}
              {subscribeStatus === 'error' && (
                <span className="text-xs text-accent-500 whitespace-nowrap">{subscribeError || '订阅失败'}</span>
              )}
            </form>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-md lg:max-w-lg">
              <div className="relative rounded-2xl overflow-hidden bg-background-100 aspect-[4/5] md:aspect-[5/4] lg:aspect-[4/5]">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20dynamic%20and%20energetic%20editorial%20illustration%20featuring%20warm%20orange%20and%20coral%20tones%2C%20abstract%20geometric%20shapes%20representing%20news%20and%20gossip%20breaking%20stories%2C%20megaphone%20and%20newspaper%20fragments%20in%20a%20collage%20style%2C%20vibrant%20energy%20with%20smooth%20gradients%2C%20modern%20minimalist%20composition%20with%20bold%20typographic%20elements%2C%20warm%20cream%20background%20with%20orange%20and%20coral%20accents%2C%20editorial%20design%20aesthetic&width=800&height=1000&seq=hero-main-2026&orientation=portrait"
                  alt="每日爆料大赛主视觉 - 吃瓜爆料平台"
                  className="w-full h-full object-cover"
                  title="每日爆料大赛 - 吃瓜爆料第一线"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}